var document = require('./_global').document;
module.exports = document && document.documentElement;



// WEBPACK FOOTER //
// ./C:/Users/Pili/AppData/Roaming/npm/~/pink/~/core-js/modules/_html.js